export var LinkAction = /*#__PURE__*/function (LinkAction) {
  LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
  LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
  LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
  LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
  LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
  return LinkAction;
}({});
export var InsertStatus = /*#__PURE__*/function (InsertStatus) {
  InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
  InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
  InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
  return InsertStatus;
}({});